<field-datetime-readonly *ngIf="field.readonly; else editable" [field]="field"></field-datetime-readonly>
<ng-template #editable>
  <field-datetime-single *ngIf="!field.multiple" [formGroup]="formGroup" [field]="field"></field-datetime-single>
</ng-template>
